import api from '../../api/stoty'
import { SET_STEP_1, SET_STEP_2, SET_STEP_3, SET_STEP_4, SET_STEP_5 } from './constants'

export const setStep1Action = payload => ({ type: SET_STEP_1, payload })
export const setStep2Action = payload => ({ type: SET_STEP_2, payload })
export const setStep3Action = payload => ({ type: SET_STEP_3, payload })
export const setStep4Action = payload => ({ type: SET_STEP_4, payload })
export const setStep5Action = payload => ({ type: SET_STEP_5, payload })

export const setStep1 = data => dispatch => dispatch(setStep1Action(data))

export const setStep2 = data => dispatch => dispatch(setStep2Action(data))

export const setStep3 = data => dispatch => dispatch(setStep3Action(data))

export const setStep4 = data => dispatch => dispatch(setStep4Action(data))

export const setStep5 = data => dispatch => dispatch(setStep5Action(data))

export const createStory = data => dispatch => api.createStory({ ...data })
  .then(res => res)
  .catch(err => err)
